import { fetchBucketFiles, syncBucketFiles } from 'api';
import useAxios from 'hooks/useAxios';
import { IBucketFileFetchRequest, IBucketFileFetchResponse } from '../../server/types';

const useFetchBucketFiles = () => {
  const [request, { loading, error, data }] = useAxios<IBucketFileFetchResponse>();

  const handleFetchBucketFiles = async (id?: string | number, params?: IBucketFileFetchRequest) => {
    const bucketFiles = await request(fetchBucketFiles(id, params));
    return bucketFiles;
  };

  return [handleFetchBucketFiles, { loading, error, data }] as const;
};

const useSyncBucketFiles = () => {
  const [request, { loading, error, data }] = useAxios();
  const handleCacheBucketFiles = async () => request(syncBucketFiles());
  return [handleCacheBucketFiles, { loading, error, data }] as const;
};

export { useFetchBucketFiles, useSyncBucketFiles };
